import React, { Component } from 'react';
import MetaDecorator from '../../services/MetaDecorator';
import sharepointlook from '../../../media/images/sharepointlook.png';
import teamslook from '../../../media/images/teamslook.png';
import powerplatformlook from '../../../media/images/powerplatformlook.png';
import azurelook from '../../../media/images/azurelook.png';
import websiteslook from '../../../media/images/websiteslook.png';
import developmentlook from '../../../media/images/developmentlook.png';
import fokus from '../../../media/images/fokus.jpg';
import fokusMobile from '../../../media/images/fokusMobile.jpg';

export default class Overview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: window.innerWidth
        };
    }
    componentDidMount = () => {
        let tabs = document.getElementsByClassName("nav-wrapper");
        if (tabs.length > 0) {
            tabs = tabs[1].querySelectorAll("ul")[0].querySelectorAll("a");
            for (let i = 0; i < tabs.length; i++) {
                tabs[i].removeAttribute('class');
                if (tabs[i].id === "scopes" || tabs[i].id === "overview") {
                    tabs[i].setAttribute('class', 'orange-text text-darken-4')
                }
            }
        }
        let mobileTabs = document.getElementsByClassName("sidenav");
        if (mobileTabs.length > 0) {
            mobileTabs = mobileTabs[0].querySelectorAll("a");
            for (let i = 0; i < mobileTabs.length; i++) {
                if (mobileTabs[i].id === "scopesMobile" || mobileTabs[i].id === "overviewMobile") {
                    mobileTabs[i].removeAttribute('class');
                    mobileTabs[i].setAttribute('class', 'orange-text text-darken-4 grey darken-3')
                }
            }
        }

        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions.bind(this));
    }

    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth });
    }

    renderOverviewMobile() {
        return (
            <div className="section">
                <div className="row">
                    <div className="col s12 center-align">
                        <h4>Microsoft SharePoint Online</h4>
                        <img className="responsive-img" style={{ width: '100%' }} src={sharepointlook} alt="Microsoft SharePoint Online" loading="lazy" />
                        <p className="light">Erleben Sie die modernen Lösungen, die wir basierend auf Microsoft SharePoint Online für Ihr Unternehmen erstellen können: Intranet, Dokumentbibliotheken als sicherer Speicherort, SharePoint Datenbanken, Kalender- und Eventlisten, Webseiten und vieles mehr. Teilen und Abrufen von Informationen von jedem Gerät und vielfältige, angepasste Geschäftslösungen gemäß Ihren Anforderungen.</p>
                        <div className="row center">
                            <a className="btn-large orange darken-4" href="/fokusbereiche/sharepoint-online" style={{ margin: '20px' }}>Mehr erfahren</a>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col s12 center-align">
                        <h4>Microsoft Power Platform</h4>
                        <img className="responsive-img" style={{ width: '100%' }} src={powerplatformlook} alt="Microsoft Power Platform" loading="lazy" />
                        <p className="light">Gemeinsames Arbeiten mit effektiven Lösungen für automatisierte Arbeitsabläufe, hochwertige Datenanalysen, smarte Businessanwendungen, moderne Chatbots und vieles mehr können wir Ihnen in Kombination mit der Microsoft Power Platform anbieten.</p>
                        <div className="row center">
                            <a className="btn-large orange darken-4" href="/fokusbereiche/power-platform" style={{ margin: '20px' }}>Weitere Details</a>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col s12 center-align">
                        <h4>Microsoft Azure</h4>
                        <img className="responsive-img" style={{ width: '100%' }} src={azurelook} alt="Microsoft Azure" loading="lazy" />
                        <p className="light">Die hoch skalierbare Cloud-Computing-Plattform von Microsoft Azure, die als IaaS Cloud-Dienste wie PaaS, SaaS sowie weitere Services weltweit bereitstellt und kontinuierlich mit neuen Diensten erweitert. Azure Synapse Analytics, Azure Cosmos DB, Azure Kubernetes Service (AKS), Azure Functions, Azure App Service, Azure Virtual Machines (VMs), Azure DevOps, Azure Machine Learning und weitere 200+ hochwertige Microsoft Azure Produkte.</p>
                        <div className="row center">
                            <a className="btn-large orange darken-4" href="/fokusbereiche/microsoft-azure" style={{ margin: '20px' }}>Jetzt entdecken</a>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col s12 center-align">
                        <h4>Microsoft Teams</h4>
                        <img className="responsive-img" style={{ width: '100%' }} src={teamslook} alt="Microsoft Teams" loading="lazy" />
                        <p className="light">Halten Sie Teambesprechungen mit 10 bis 10.000 internen oder externen Teilnehmern per Audio-, Video- und Webkonferenz ab. Veranstalten Sie große Live-Events und zahlreiche Möglichkeiten der Kommunikation im Unternehmen. Arbeiten Sie gemeinsam im Team und tauschen schnell Dateien und Informationen mit anderen Teammitgliedern aus und sorgen somit für eine produktive Zusammenarbeit.</p>
                        <div className="row center">
                            <a className="btn-large orange darken-4" href="/fokusbereiche/microsoft-teams" style={{ margin: '20px' }}>Weitere aspekte</a>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col s12 center-align">
                        <h4>Softwareentwicklung</h4>
                        <img className="responsive-img" style={{ width: '100%' }} src={developmentlook} alt="Softwareentwicklung" loading="lazy" />
                        <p className="light">Innovative, maßgefertigte Software- und Weblösungen auf Basis von Microsoft SharePoint Online, Azure, Power Platform und Microsoft Teams für Ihre speziellen Anforderungen. Mit den modernsten Technologien und den Microsoft Best Practices entwickeln wir maßgenaue Add-Ins, die das User-Experience-Design (UX) deutlich verbessern und sehr moderne User-Interface-Design (UI) gewährleisten.</p>
                        <div className="row center">
                            <a className="btn-large orange darken-4" href="/fokusbereiche/softwareentwicklung" style={{ margin: '20px' }}>Mehr Information</a>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col s12 center-align">
                        <h4>Webseiten</h4>
                        <img className="responsive-img" style={{ width: '100%' }} src={websiteslook} alt="Webseiten" loading="lazy" />
                        <p className="light">Hierbei liegt unser Fokus auf Konzeption, Webdesign, modernes UI, benutzerfreundliches UX, Webentwicklung, SEO, Analytics und CMS. Als Dienstleister für moderne Informationstechnologien und digitale Transformation sehen wir Webseiten als digitale Präsenz im Zentrum der Unternehmenskommunikation, die eine große Bedeutung im Online Marketing darstellt.</p>
                        <div className="row center">
                            <a className="btn-large orange darken-4" href="/fokusbereiche/webseiten" style={{ margin: '20px' }}>Detaillierte Angaben</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderOverview() {
        return (
            <div className="section">
                <div className="row showOverview">
                    <div className="col s12 m4 center-align">
                        <h4>Microsoft SharePoint</h4>
                        <p className="light">Erleben Sie die modernen Lösungen, die wir basierend auf Microsoft SharePoint Online für Ihr Unternehmen erstellen können: Intranet, Dokumentbibliotheken als sicherer Speicherort, SharePoint Datenbanken, Kalender- und Eventlisten, Webseiten und vieles mehr. Teilen und Abrufen von Informationen von jedem Gerät und vielfältige, angepasste Geschäftslösungen gemäß Ihren Anforderungen.</p>
                        <div className="row center">
                            <a className="btn-large orange darken-4" href="/fokusbereiche/sharepoint-online" style={{ margin: '20px' }}>Mehr erfahren</a>
                        </div>
                    </div>
                    <div className="col s12 m8">
                        <img className="responsive-img" style={{ width: '100%' }} src={sharepointlook} alt="Microsoft SharePoint Online" loading="lazy" />
                    </div>
                </div>
                <div className="row showOverview">
                    <div className="col s12 m8">
                        <img className="responsive-img" style={{ width: '100%' }} src={powerplatformlook} alt="Microsoft Power Platform" loading="lazy" />
                    </div>
                    <div className="col s12 m4 center-align">
                        <h4>Microsoft Power Platform</h4>
                        <p className="light">Gemeinsames Arbeiten mit effektiven Lösungen für automatisierte Arbeitsabläufe, hochwertige Datenanalysen, smarte Businessanwendungen, moderne Chatbots und vieles mehr können wir Ihnen in Kombination mit der Microsoft Power Platform anbieten.</p>
                        <div className="row center">
                            <a className="btn-large orange darken-4" href="/fokusbereiche/power-platform" style={{ margin: '20px' }}>Weitere Details</a>
                        </div>
                    </div>
                </div>
                <div className="row showOverview">
                    <div className="col s12 m4 center-align">
                        <h4>Microsoft Azure</h4>
                        <p className="light">Die hoch skalierbare Cloud-Computing-Plattform von Microsoft Azure, die als IaaS Cloud-Dienste wie PaaS, SaaS sowie weitere Services weltweit bereitstellt und kontinuierlich mit neuen Diensten erweitert. Azure Synapse Analytics, Azure Cosmos DB, Azure Kubernetes Service (AKS), Azure Functions, Azure App Service, Azure Virtual Machines (VMs), Azure DevOps, Azure Machine Learning und weitere 200+ hochwertige Microsoft Azure Produkte.</p>
                        <div className="row center">
                            <a className="btn-large orange darken-4" href="/fokusbereiche/microsoft-azure" style={{ margin: '20px' }}>Jetzt entdecken</a>
                        </div>
                    </div>
                    <div className="col s12 m8">
                        <img className="responsive-img" style={{ width: '100%' }} src={azurelook} alt="Microsoft Azure" loading="lazy" />
                    </div>
                </div>
                <div className="row showOverview">
                    <div className="col s12 m8">
                        <img className="responsive-img" style={{ width: '100%' }} src={teamslook} alt="Microsoft Teams" loading="lazy" />
                    </div>
                    <div className="col s12 m4 center-align">
                        <h4>Microsoft Teams</h4>
                        <p className="light">Halten Sie Teambesprechungen mit 10 bis 10.000 internen oder externen Teilnehmern per Audio-, Video- und Webkonferenz ab. Veranstalten Sie große Live-Events und zahlreiche Möglichkeiten der Kommunikation im Unternehmen. Arbeiten Sie gemeinsam im Team und tauschen schnell Dateien und Informationen mit anderen Teammitgliedern aus und sorgen somit für eine produktive Zusammenarbeit.</p>
                        <div className="row center">
                            <a className="btn-large orange darken-4" href="/fokusbereiche/microsoft-teams" style={{ margin: '20px' }}>Weitere aspekte</a>
                        </div>
                    </div>
                </div>
                <div className="row showOverview">
                    <div className="col s12 m4 center-align">
                        <h4>Softwareentwicklung</h4>
                        <p className="light">Innovative, maßgefertigte Software- und Weblösungen auf Basis von Microsoft SharePoint Online, Azure, Power Platform und Microsoft Teams für Ihre speziellen Anforderungen. Mit den modernsten Technologien und den Microsoft Best Practices entwickeln wir maßgenaue Add-Ins, die das User-Experience-Design (UX) deutlich verbessern und sehr moderne User-Interface-Design (UI) gewährleisten.</p>
                        <div className="row center">
                            <a className="btn-large orange darken-4" href="/fokusbereiche/softwareentwicklung" style={{ margin: '20px' }}>Mehr Information</a>
                        </div>
                    </div>
                    <div className="col s12 m8">
                        <img className="responsive-img" style={{ width: '100%' }} src={developmentlook} alt="Softwareentwicklung" loading="lazy" />
                    </div>
                </div>
                <div className="row showOverview">
                    <div className="col s12 m8">
                        <img className="responsive-img" style={{ width: '100%' }} src={websiteslook} alt="Webseiten" loading="lazy" />
                    </div>
                    <div className="col s12 m4 center-align">
                        <h4>Webseiten</h4>
                        <p className="light">Hierbei liegt unser Fokus auf Konzeption, Webdesign, modernes UI, benutzerfreundliches UX, Webentwicklung, SEO, Analytics und CMS. Als Dienstleister für moderne Informationstechnologien und digitale Transformation sehen wir Webseiten als digitale Präsenz im Zentrum der Unternehmenskommunikation, die eine große Bedeutung im Online Marketing darstellt.</p>
                        <div className="row center">
                            <a className="btn-large orange darken-4" href="/fokusbereiche/webseiten" style={{ margin: '20px' }}>Detaillierte Angaben</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { width } = this.state;
        const isMobile = width <= 600;
        const isTablet = width <= 992 && width > 600;
        return (
            <React.Fragment>
                <MetaDecorator
                    title="JetMinds | Fokusbereiche und Expertise für Microsoft 365"
                    descrption="Wir bieten Ihnen Beratung, Konzeption und Umsetzung im Bereich Microsoft SharePoint Online, Microsoft Teams, Microsoft Power Platform, Azure, Sofwareentwicklung und Webseiten an"
                    url="https://www.jetminds.de/fokusbereiche/" />
                <div className="pageImageTitle">
                    {isMobile ?
                        <img className="responsive-img" style={{ width: '100%' }} src={fokusMobile} alt="JetMinds Fokusbereiche" loading="lazy" /> :
                        <img className="responsive-img" style={{ width: '100%' }} src={fokus} alt="JetMinds Fokusbereiche" loading="lazy" />}
                    {isMobile || isTablet ?
                        <div className="imgTxtMobile">
                            <h1 className={`white-text ${isTablet ? "isTablet" : "isMobile"}`}>Fokusbereiche</h1>
                        </div>
                        :
                        <div className="imgTxt">
                            <h1 className="white-text">Unsere Fokusbereiche</h1>
                        </div>}
                </div>
                {isMobile || isTablet ?
                    <div className="container">
                        {this.renderOverviewMobile()}
                    </div>
                    :
                    this.renderOverview()
                }
            </React.Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/layout/pages/Overview.js